import { ReactNode } from 'react';
import { Box, FormHelperTextProps } from '@mui/material';
import { IInputLabel, InputLabel } from '@components/inputLabel';
import { FormHelperText } from '@components/index';
import { AdditionalInfoLink, AdditionalInfoLinkProps } from '@components/container/AdditionalInfoLink';
export interface IInputLabelContainer {
  children: ReactNode;
  inputLabelProps?: IInputLabel;
  helperLabelProps?: FormHelperTextProps;
  additionalInfoLink?: AdditionalInfoLinkProps;
  allowHelperLabelWrap?: boolean;
}

export const InputLabelContainer = ({
  children,
  inputLabelProps,
  helperLabelProps,
  additionalInfoLink,
  allowHelperLabelWrap,
}: IInputLabelContainer) => {
  const { id } = inputLabelProps || {};
  const labelFieldId = id ? `${id}-label` : undefined;

  return (
    <>
      {inputLabelProps?.children ? <InputLabel {...inputLabelProps} id={labelFieldId} /> : null}
      {/* make the link hug the label a little bit :) */}
      <Box sx={additionalInfoLink ? { mt: -0.5 } : {}}>
        {additionalInfoLink && <AdditionalInfoLink {...additionalInfoLink} />}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            alignContent: 'start',
          }}
        >
          {children}
        </Box>
        <Box
          sx={
            allowHelperLabelWrap
              ? {}
              : {
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textWrap: 'nowrap',
                  whiteSpace: 'nowrap',
                }
          }
        >
          {helperLabelProps?.children ? <FormHelperText {...helperLabelProps} /> : null}
        </Box>
      </Box>
    </>
  );
};
